import React, { memo } from 'react';
import { Form, mergeFieldProps } from '@widergy/utilitygo-forms-web';
import { Field } from 'redux-form';
import { any, bool, shape, string, arrayOf } from 'prop-types';

import { accountPropTypes } from 'redux/accountHandlers';

import { DefaultMessages, Components, FieldsConfig } from './constants';
import styles from './styles.module.scss';

const UTForm = ({
  form,
  fields,
  fieldValues,
  showTitle,
  account,
  formClasses,
  fieldClasses = {},
  replaceFieldNames,
  disableAllFields,
  isPublic,
  fieldTypeProps,
  ignoreVisibility
}) => {
  const fieldProps = mergeFieldProps(fieldTypeProps, FieldsConfig());
  return (
    <Form
      form={form}
      fields={fields}
      fieldValues={fieldValues}
      components={Components}
      showTitle={showTitle}
      account={account}
      disableAllFields={disableAllFields}
      defaultMessages={DefaultMessages}
      formClasses={formClasses}
      fieldClasses={{
        title: styles.title,
        container: `${styles.fieldContainer} ${fieldClasses.container}`,
        error: fieldClasses.error
      }}
      FieldComponent={Field}
      replaceFieldNames={replaceFieldNames}
      isPublic={isPublic}
      ignoreVisibility={ignoreVisibility}
      fieldTypeProps={fieldProps}
    />
  );
};

UTForm.propTypes = {
  form: any, // eslint-disable-line react/forbid-prop-types
  fields: any, // eslint-disable-line react/forbid-prop-types
  fieldTypeProps: any, // eslint-disable-line react/forbid-prop-types
  fieldValues: arrayOf(shape({ key: string })),
  showTitle: bool,
  isPublic: bool,
  disableAllFields: bool,
  replaceFieldNames: bool,
  account: accountPropTypes,
  formClasses: shape({ formContainer: string, formTitle: string, fieldRowContainer: string }),
  fieldClasses: shape({ container: string, comment: string, error: string }),
  ignoreVisibility: bool
};

export default memo(UTForm);
